import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

interface WrittenDirectiveResponse {
  contentHeading: string;
  contentTitle: string;
  contentUri: string;
  id: string;
  jurisdictionId: string;
  manualTitle: string;
  standardId: string;
  taggedAll: boolean;
}

interface CreateWrittenDirectiveRequest {
  contentUri: string;
}

export const createWrittenDirective = async (
  accreditationId: string,
  versionId: string,
  standardId: string,
  jurisdictionId: string,
  data: CreateWrittenDirectiveRequest,
  callback?: (data: WrittenDirectiveResponse) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationId}/versions/${versionId}/standards/${standardId}/jurisdiction/${jurisdictionId}/written-directives`;
  try {
    const response: WrittenDirectiveResponse = await fetcher({
      url,
      method: 'post',
      body: data,
    });
    if (callback) callback(response);
    return response;
  } catch (err: any) {
    if (onError) {
      handleError(err, { onError });
    }
    throw err;
  }
};

export const destroyWrittenDirective = async (
  accreditationId: string,
  versionId: string,
  standardId: string,
  writtenDirectiveId: string,
  callback?: () => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationId}/versions/${versionId}/standards/${standardId}/written-directives/${writtenDirectiveId}`;
  await fetcher({
    url,
    method: 'delete',
    body: {},
  })
    .then(() => {
      if (callback) callback();
    })
    .catch((err) => {
      console.warn('delete err', err);
      if (onError) handleError(err, { onError });
    });
};

export const getWrittenDirectives = async (
  accreditationId: string,
  versionId: string,
  standardId: string,
  jurisdictionId: string,
  callback?: (data: WrittenDirectiveResponse[]) => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationId}/versions/${versionId}/standards/${standardId}/jurisdiction/${jurisdictionId}/written-directives`;
  try {
    const response: { content: WrittenDirectiveResponse[] } = await fetcher({
      url,
      method: 'get',
    });
    if (callback) callback(response.content);
    return response.content;
  } catch (err: any) {
    if (onError) {
      handleError(err, { onError });
    }
    throw err;
  }
};
